import React, { FC } from 'react'
import { observer } from 'mobx-react'
import themeMobx from '@mobx/app/theme.mobx'
import './index.scss'

// props
interface IProps {
  /** padding */
  padding?: number;
  /** shadow */
  shadow?: boolean;
}

const Line: FC<IProps> = ({ padding, shadow = false }) => {
  return (
    <div
      className={`line${shadow ? ' shadow' : ''} ${themeMobx.data.backgroundMode}`}
      style={{ padding: `0 ${padding}px` }}
    />
  )
}

export default observer(Line)
